<template>
<div>
    
    <v-container class="pt-16">
        <h2>Política de privacidad</h2>
        <v-row class="pt-10">
            
            <v-col cols="12">
                Aiko Limitada (Aiko) ha construido la aplicación Kefuri para IOS y Android, las cuales se entregan de manera gratuita. Este servicio se provee sin costo y su uso tal cual como se entrega.
                Esta página existe para informar a los visitantes sobre nuestras políticas de recolección, uso y confidenciabilidad de Información Personal si es que alguien usa el servicio.
                Si eliges usar nuestro servicio, entonces aceptas a la recolección y uso de informción de acuerdo a nuestras políticas. La información personal que recolectamos es usada para utilizar y mejorar el servicio prestado. No usaremos ni compartiremos tu información con nadie fuera de lo explicitado en esta política de privacidad.
            </v-col>
            <v-col cols="12">
                <h3>Recolección de información y uso</h3>
                <p>
                    Para una mejor experiencia, mientras se usan nuestros servicios, podremos requerir cierta información personal, incluyendo y ni limitado al identificador del dispositivo a usar. La información que requerimos será retenido por nosotros y usada como se describe en esta política.
                    Nuestras aplicaciones usan servicios de externos que pueden recolectar información para identificarte. Los siguientes enlaces llevan a las políticas de privacidad de los servicios externos usados por nuestras aplicaciones.
                </p>
                <ul>
                    <li><a target="_blank" href="https://policies.google.com/privacy"> Google Play Services </a></li>
                    <li><a target="_blank" href="https://firebase.google.com/policies/analytics"> Firebase Analytics </a></li>
                </ul>
            </v-col>

            <v-col cols="12">
                <h3>Registro de Datos</h3>
                <p>
                    Queremos informarte que cada vez que usas una de nuestras aplicaciones, en el caso de error de éstas, nosotros recolectamos información y datos (a través de servicios de terceros) en tu teléfono llamados registros de datos (log data). Este registro puede incluir información tal como tu dirección IP, el nombre del dispositivo, sistema operativo, la configuración de la app cuando utilizas nuestro servicio, la fecha del uso de nuestro servicio, y otras estadísticas.
                </p>

            </v-col>
            <v-col cols="12">
                <h3>Cookies</h3>
                <p>
                    Las cookies son archivos con una pequeña cantidad de información que son comunmente usados como identificadores anónimos únicos. Estas son enviadas a tu navegador desde los sitios que visitas y guardadas en la memoria interna de tu dispositivo.
                    Nuestro servicio no usa estas "cookies" de manera explicita. Sin embargo, las aplicaciones pueden usar código de terceros y librerías que usen estas cookies para recolectar información para mejorar sus servicios. Tu tienes la opción de aceptar o rechazar estas cookies y saber cuando una cookie es enviada a tu dispositivo. Si eliges rechazar las cookies, entonces una porción del servicio podría quedar inutilizadas.
                </p>
            </v-col>

            <v-col cols="12">
                <h3>Provedores de Servicios Externos</h3>
                <p>
                    Podríamos utilizar servicios de compañías e individuales externos por las siguientes razones:
                </p>
                <ul>
                    <li>Para facilitar nuestro servicio</li>
                    <li>Para proveer el servicio en nuestro nombre</li>
                    <li>Para realizar servicios relacionados</li>
                    <li>Para asistirnos en analizar cómo nuestro servicio es usado</li>
                </ul>
                <p>Informamos a nuestros ususarios que estos terceros tienen acceso a tu información personsal. La razón de ello es para realizar las tareas que les asignamos en nuestro nombre. Sin embargo, ellos están obligados a no revelar ni usar la información para cualquier otro propósito.</p>
            </v-col>

            <v-col cols="12">
                <h3>Seguridad</h3>
                <p>
                    Valoramos que confies en proveer tu información personal en nosotros, es por ello que nos preocupamos de mantener tu información protegida. Pero debes tener en cuenta que ningún método de transmisión por internet o algún medio de respaldo electrónico es 100% seguro y confiable, por lo que no podemos garantizar una seguridad absoluta.
                </p>
            </v-col>
            <v-col cols="12">
                <h3>Enlaces a otros sitios</h3>
                <p>
                    Este servicio puede contener enlaces a otros sitios. Si haces click en un enlace de un agente externo, podrías ser redirigido a ese sitio. Estos sitios externos no son operados por nosotros, por lo que recomendamos que revises las políticas de privacidad de cada sitio. No tenemos control ni asumimos la responsabilidad por el contenido, las políticas de privacidad ni las prácticas que tenga cualquier sitio o servicio de terceros.
                </p>
            </v-col>
            <v-col cols="12">
                <h3>Privacidad Infantil</h3>
                <p>
                    Las aplicaciones de Kefuri están pensadas para profesionales de la salud, es por ello que los servicios ofrecidos no son ofrecidos a menores de 13 años. Por lo mismo, información identificable de menores de 13 años no es guardada. En caso de ser descubierta será eliminada. En el caso de los pacientes, estos datos serán guardados para ser solo vistos por los profesionales de salud a cargo de ellos, tal como lo establece la ley Chilena.
                </p>
            </v-col>
            <v-col cols="12">
                <h3>Cambios en esta Política de Privacidad</h3>
                <p>
                    Esta Política de Privacidad podría ser actualizada de vez en cuando. Así, se aconseja revisar esta página periodicamnete por cualquier cambio. Notificaremos por cualquier cambio posteado en esta página. Todos los cambios toman efecto inmediato al ser estipulados en esta página.
                </p>
            </v-col>
            <v-col cols="12">
                <h3>Contáctanos</h3>
                <p>
                Si tienes cualquier duda contáctanos a contacto@kefuri.cl
                </p>
            </v-col>
            
        </v-row>
        
    </v-container>
    </div>    
</template>

<script>
export default {
    name: 'Politicas-publicas',
    components: {

    }
    
}
</script>

<style scoped lang="sass">

    .card-team 
        min-height: 290px

</style>